
<ngx-spinner bdColor="rgba(255, 255, 255, 0.8)" color="#175331" type="ball-scale-multiple" size="medium"></ngx-spinner>

<div class="toaster-container d-flex flex-column align-items-center justify-content-center">
<div *ngFor="let notification of notifications" [ngClass]="notification.type" class="my-1 toaster">
  <i class="toaster-icon mx-3" [ngClass]="{
      'ri-checkbox-circle-line': notification.type === 'success',
      'ri-close-circle-line': notification.type === 'error',
      'ri-error-warning-line': notification.type === 'warning',
      'ri-information-line': notification.type === 'info'
    }"></i>
  <h5 class="me-auto" [routerLink]="['/notifications/list']">{{notification.message}}</h5>
  <button mat-icon-button class="mx-3" (click)="removeNotification(notification)">
    <i class="ri-close-line"></i>
  </button>
</div>
</div>
  <router-outlet></router-outlet>



